import { Directive } from "vue"

const check = (el: unknown) => {
  if(!(el instanceof HTMLElement)) return false
  
  const overflow =
    el.offsetHeight < el.scrollHeight ||
    el.offsetWidth < el.scrollWidth
  
  return overflow
}

const dispatch = (el: HTMLElement) => {
  const overflow = check(el)
  
  const event = new CustomEvent<boolean>("overflow-status", {
    detail: overflow
  })

  el.dispatchEvent(event)
}

export const watchOverflow: Directive = {
  mounted: (el) => {
    if(!(el instanceof HTMLElement)) return false

    const observer = new ResizeObserver(
      entries => entries.forEach(
        e => dispatch(e.target as HTMLElement)
      )
    )
    
    // eslint-disable-next-line
    // @ts-ignore
    el.observer = observer

    observer.observe(el)
    dispatch(el)
  },
  updated: (el) => {
    if(!(el instanceof HTMLElement)) return

    dispatch(el)
  },
  unmounted: (el) => {
    // eslint-disable-next-line
    // @ts-ignore
    const observer = el.observer

    if(observer) observer.disconnect()
  }
}
